var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "coupon-reward-container" },
    [
      _c(
        "div",
        [
          _vm._v("\n    奖品类型：\n    "),
          _c(
            "el-select",
            {
              staticStyle: { width: "120px" },
              attrs: { size: "small", placeholder: "请选择奖品类型" },
              model: {
                value: _vm.couponReward.prizeType,
                callback: function ($$v) {
                  _vm.$set(_vm.couponReward, "prizeType", $$v)
                },
                expression: "couponReward.prizeType",
              },
            },
            [
              _c("el-option", { attrs: { label: "代金券", value: 1 } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "积分", value: 2 } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-divider", { attrs: { direction: "vertical" } }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.couponReward.prizeType === 1
        ? _c(
            "div",
            [
              _vm._v("\n    代金券：\n    "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "300px" },
                  attrs: {
                    loading: _vm.couponLoading,
                    placeholder: "请选择代金券 支持模糊搜索",
                    clearable: "",
                    filterable: "",
                    size: "small",
                    "reserve-keyword": "",
                    remote: "",
                    "remote-method": _vm.queryCouponList,
                  },
                  model: {
                    value: _vm.couponReward.couponId,
                    callback: function ($$v) {
                      _vm.$set(_vm.couponReward, "couponId", $$v)
                    },
                    expression: "couponReward.couponId",
                  },
                },
                _vm._l(_vm.couponList, function (item, index) {
                  return _c(
                    "el-option",
                    {
                      key: item.value + "_" + index,
                      attrs: {
                        label: "[" + item.value + "]" + item.label,
                        value: item.value,
                      },
                    },
                    [
                      _c("span", { staticStyle: { float: "left" } }, [
                        _vm._v(
                          "[" + _vm._s(item.value) + "] " + _vm._s(item.label)
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            float: "right",
                            color: "#8492a6",
                            "font-size": "13px",
                          },
                        },
                        [_vm._v(" [" + _vm._s(item.couponPayVal) + "]")]
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c("el-divider", { attrs: { direction: "vertical" } }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.couponReward.prizeType === 1
        ? _c(
            "div",
            [
              _vm._v("\n    券库存："),
              _c("el-input-number", {
                staticStyle: { width: "200px" },
                attrs: {
                  size: "small",
                  placeholder: "请输入券库存",
                  min: 1,
                  max: 999999,
                },
                model: {
                  value: _vm.couponReward.stock,
                  callback: function ($$v) {
                    _vm.$set(_vm.couponReward, "stock", $$v)
                  },
                  expression: "couponReward.stock",
                },
              }),
              _vm._v(" "),
              _c("el-divider", { attrs: { direction: "vertical" } }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.couponReward.prizeType === 1
        ? _c(
            "div",
            [
              _vm._v("\n    单次发放数量："),
              _c("el-input-number", {
                attrs: {
                  size: "small",
                  placeholder: "请输入单次发放数量",
                  min: 1,
                  max: 999999,
                },
                model: {
                  value: _vm.couponReward.couponCount,
                  callback: function ($$v) {
                    _vm.$set(_vm.couponReward, "couponCount", $$v)
                  },
                  expression: "couponReward.couponCount",
                },
              }),
              _vm._v(" "),
              _c("el-divider", { attrs: { direction: "vertical" } }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.couponReward.prizeType === 2
        ? _c(
            "div",
            [
              _vm._v("\n    积分："),
              _c("el-input-number", {
                attrs: {
                  size: "small",
                  placeholder: "请输入积分",
                  min: 1,
                  max: 999999,
                },
                model: {
                  value: _vm.couponReward.integral,
                  callback: function ($$v) {
                    _vm.$set(_vm.couponReward, "integral", $$v)
                  },
                  expression: "couponReward.integral",
                },
              }),
              _vm._v(" "),
              _c("el-divider", { attrs: { direction: "vertical" } }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm._v("\n    中奖率："),
          _c("el-input-number", {
            attrs: {
              size: "small",
              placeholder: "请输入中奖率",
              min: 0,
              step: 0.1,
              precision: 1,
              max: 100,
            },
            model: {
              value: _vm.couponReward.winRate,
              callback: function ($$v) {
                _vm.$set(_vm.couponReward, "winRate", $$v)
              },
              expression: "couponReward.winRate",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-divider", { attrs: { direction: "vertical" } }),
      _vm._v(" "),
      _c("div", [_vm._t("action")], 2),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }